import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IPerformanceState} from "../reducers/performance.reducer";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getPerformanceState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.performance);

export const getPerformancesHistory = (websiteId: number) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
    state.entities[websiteId] && state.entities[websiteId].historyEntities ? Object.values(state.entities[websiteId].historyEntities) : []
);

export const getPerformancesHistoryMap = (websiteId: number) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
    state.entities[websiteId] && state.entities[websiteId].historyEntities ? state.entities[websiteId].historyEntities : []
);

export const getPerformancesHistoryLoading = (websiteId: number) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
    state.entities[websiteId] && state.entities[websiteId].historyEntities ? state.entities[websiteId].loading : false
);


export const getPerformancesHistoryLoaded = (websiteId: number) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
    state.entities[websiteId] && state.entities[websiteId].historyEntities ? state.entities[websiteId].loaded : false
);

export const getPerformancesTest = (payload: {websiteId: number, performanceTestId: string}) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
  state.entities[payload.websiteId] && state.entities[payload.websiteId].testEntities && state.entities[payload.websiteId].testEntities[payload.performanceTestId] ? state.entities[payload.websiteId].testEntities[payload.performanceTestId].performanceTest : {}
);

export const getPerformancesTestMapper = (payload: {websiteId: number, performanceTestId: string}) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
    state.entities[payload.websiteId] && state.entities[payload.websiteId].testEntities ? state.entities[payload.websiteId].testEntities[payload.performanceTestId].performanceTest : {}
);

export const getPerformancesTestLoading = (payload: {websiteId: number, performanceTestId: string}) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
    state.entities[payload.websiteId] ? state.entities[payload.websiteId].loading : false
);

export const getPerformancesTestLoaded = (payload: {websiteId: number, performanceTestId: string}) => createSelector(getPerformanceState,
  (state: IPerformanceState) =>
    state.entities[payload.websiteId] ? state.entities[payload.websiteId].loaded : false
);
